<template>
  <div class="configurator-page-search-results">
    <div class="configurator-page-search-results__header">
      <h2>{{ pointStore.search.heading }}</h2>
      <p class="configurator-page-search-result__text">
        {{ pointStore.search.showing }} <strong>{{ pointStore.searchResults }} {{
          pointStore.search.results
        }}&nbsp;</strong>

        <span
            v-if="pointStore.selectedCategories.length !== 0 || pointStore.selectedProducts.length !== 0 || pointStore.selectedDepths.length !== 0"> 
          {{ pointStore.search.match }}&nbsp;
        </span>

        <span class="configurator-page-search-results__text configurator-page-search-results__text--selected"
              v-for="category in pointStore.selectedCategories" v-bind:key="category.id">
          {{ category.name }}
        </span>

        <span class="configurator-page-search-results__text configurator-page-search-results__text--selected"
              v-for="depth in pointStore.selectedDepths" v-bind:key="depth.id">
          {{ depth.range }}
        </span>

        <span class="configurator-page-search-results__text configurator-page-search-results__text--selected"
              v-for="product in pointStore.selectedProducts" v-bind:key="product.id">
          {{ product.familyName }}
        </span>
      </p>
      <a class="configurator-page-search-results__clear" @click="clearFilter"
         v-if="pointStore.selectedCategories.length !== 0 || pointStore.selectedProducts.length !== 0 || pointStore.selectedDepths.length !== 0">
        {{ pointStore.filter.clear }}<span>&times;</span>
      </a>
    </div>

    <div class="configurator-page-search-results__list">
      <ToolPreview
          v-for="(point, index) in pointStore.enabledPoints"
          v-bind:key="point.articleNr"
          :index="index"
          :point="point"
          @togglePoint="togglePoint"
      />
    </div>
  </div>
  <Transition name="fade">
    <SelectedPoint @togglePoint="togglePoint" v-if="!!pointStore.selectedPoint"/>
  </Transition>
</template>

<script setup>
import {usePointStore} from '../store/store';
import SelectedPoint from './selectedPoint.vue';
import ToolPreview from './toolPreview.vue';

const pointStore = usePointStore();

const props = defineProps({
  points: Array,
  enabledPoints: Array,
  selectedPoint: Object,
  selectedProducts: Array,
  selectedCategories: Array,
  selectedDepths: Array,
  searchResult: Number,
  search: Object,
  filter: Object
});

const emit = defineEmits([
  'clearFilter',
  'togglePoint',
  'marathon'
]);

function clearFilter() {
  emit('clearFilter', event);
}

function togglePoint(point) {
  emit('togglePoint', point, false);
}
</script>